import React from "react";
import Navbar from "../navbar/navbar";
import { Link } from "react-router-dom";
import { useState,useEffect } from "react";
import api from "../../services/api";
import { vhostV1, vhostV2 } from "../funcoes";
import './empresa.css';
import customizeScrollbar from "customsb";
import FooterBar from "../footer/footerBar";
import { Container, Typography, Grid, Paper, Box, Divider } from '@mui/material';


function Empresa(){

     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [empresas,setEmpresas] = useState([]);
     const [sResult,setSresult] = useState('N');
     const [empresaDetalhada, setEmpresaDetalhada] = useState();
    
     const cnpj = "54252373000189"
     const [empresaApi, setEmpresaApi] = useState()

     let config = {
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }

      let config2 = {
        headers: {
          'Authorization': localStorage.getItem("token2")
        }
      }


    //  useEffect(function(){
    
    //     api.post(vhostV2('webcash/empresa/lista'), {
    //         loja: localStorage.getItem('loja')
            
    //       },config2)
    //       .then(function (response) {           
    //         setEmpresas(response.data.dados); 
    //         setSresult(response.data.result);
            
                                        
                     
    //       })
    //       .catch(function (error) {
           
    //         console.log(error);
  
                    
    //       });
    
          
    //     },[busca])


        useEffect(function(){
    
          api.post(vhostV1('webcash/Empresa/retornaEmpresa'),{},config)
            .then(function (response) {           
              console.log(response);
              setEmpresaDetalhada(response.data.dados);
              
              
                                          
                       
            })
            .catch(function (error) {
             
              console.log(error);
    
                      
            });
      
            
          },[busca])

          useEffect(function () {
            if (!cnpj) return; // evita chamada com CNPJ vazio

             fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`)
             .then(function (response) {
               if (!response.ok) {
                throw new Error('Erro na resposta da API');
               }
                 return response.json();
               })
            .then(function (data) {
             console.log('Dados da empresa:', data);
              setEmpresaApi(data);
              })
            .catch(function (error) {
             console.error('Erro ao buscar dados da empresa:', error);
             setEmpresaApi(null);
            });
            }, [busca]);

         // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);




    return  <div>
      <Navbar />

      <Container maxWidth="xl" sx={{ mt: 6, mb: 8 }}>
        <Paper elevation={3} sx={{ p: 6, borderRadius: 3 }}>
          <Typography variant="h4" gutterBottom>
            Detalhes da Empresa
          </Typography>
          <Divider sx={{ mb: 4 }} />

          {empresaDetalhada && (
            <Grid container spacing={5}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    CNPJ:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.CGC}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Razão Social:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.RAZAO_SOCIAL}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Nome Fantasia:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.FANTASIA}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Endereço:
                  </Typography>
                  <Typography variant="body1">
                    {empresaDetalhada.ENDERECO}, {empresaDetalhada.NR}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Bairro:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.BAIRRO}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Cidade:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.CIDADE}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    UF:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.UF}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    CEP:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.CEP}</Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Regime:
                  </Typography>
                  <Typography variant="body1">
                    {empresaDetalhada.REGIME === 2 ? 'Regime Normal' : 'Simples Nacional'}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Telefone:
                  </Typography>
                  <Typography variant="body1">{empresaDetalhada.TELEFONE}</Typography>
                </Box>
              </Grid>
            </Grid>
          )}
        </Paper>
      </Container>

      <FooterBar />
    </div>




}



export default Empresa;